import './QrCodeScreen.scss';
import React, {useCallback, useEffect, useState} from "react";
import QrCodeListTableComponent from "./qr-code-table/QrCodeListComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import AddIcon from "@mui/icons-material/Add";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import QrCodeFormComponent from "../../shared/components/qrcode-form/qrCodeFormComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import commonService from "../../shared/services/common.service";

const QrCodeListScreen = () => {
    const [openAddQrDrawer, setOpenAddQrDrawer] = useState<boolean>(false);

    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("QR Code", "QR Code"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const loggedInUserLocationDetails = (currentUser?.roleObj?.code === 'locationAdmin') ? currentUser.locationDetails : null;

    const handleInsuranceDrawerClose = useCallback(() => {
        setOpenAddQrDrawer(false);
    }, []);

    return (
        <div className="qr-code-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            {/*<InputComponent type={"text"}*/}
                            {/*                size={"small"}*/}
                            {/*                label={"Search QR Code"}*/}
                            {/*                name={"Search"}*/}
                            {/*                id="search_input"*/}
                            {/*                placeholder={"QR Code"}*/}
                            {/*                value={qrCodeList?.table?.filter?.search}*/}
                            {/*                onChange={(value: string) => {*/}
                            {/*                    if (qrCodeList && qrCodeList.table) {*/}
                            {/*                        qrCodeList.table.filter.search = value;*/}
                            {/*                        qrCodeList.table.reload(1);*/}
                            {/*                    }*/}
                            {/*                }}*/}
                            {/*/>*/}
                        </div>
                        <div className="page-extra-options">
                            {
                                commonService.checkAccess('QrCodes', 'QRCodesGenerate', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    id="add_test_order_btn"
                                    startIcon={<AddIcon/>}
                                    handleClick={() => {
                                        setOpenAddQrDrawer(true)
                                    }}
                                >
                                    New QR Code
                                </ButtonComponent>
                            }
                        </div>
                    </div>
                    <>
                        <QrCodeListTableComponent loggedInUserLocationDetails={loggedInUserLocationDetails}/>
                    </>
                </div>

            </div>
            <DrawerComponent
                open={openAddQrDrawer}
                className={"drawer-wrapper"}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                onClose={() => handleInsuranceDrawerClose()}
            >
                <QrCodeFormComponent
                    loggedInUser={loggedInUserLocationDetails}
                    onUpdateComplete={(data: any) => {
                        handleInsuranceDrawerClose();
                    }}
                />
            </DrawerComponent>
        </div>
    )
};
export default QrCodeListScreen;
